module.exports = __webpack_public_path__ + "static/sample-4b136687b8cec47f1ca7daa226ba61a0.png";